module.exports = __webpack_public_path__ + "static/media/nada.6f85ed23.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/AdvisorsPartnersTeamResources/nada.jpg
// module id = 230
// module chunks = 0